<template>
    <div>
        <h1 class="text-3xl text-slate-800 font-semibold mb-2 leading-9">
            Setup Two Factor Authentication
        </h1>

        <p class="text-slate-800 text-sm mb-4">
            Two factor authentication (or 2FA) adds an extra laver of security
            to your account. You can also do this later from your account
            settings page.
        </p>

        <label
            class="block px-4 py-3 rounded-lg border border-slate-200 hover:bg-slate-100 transition-colors mb-4"
            :class="{ 'bg-slate-100': twoFactorType === 'totp' }"
        >
            <span
                class="flex items-center gap-2 text-slate-800 text-sm font-medium mb-1"
            >
                <input
                    type="radio"
                    name="two_factor_type"
                    v-model="twoFactorType"
                    value="totp"
                    class="form-radio"
                />
                <span>Through Google Authenticator App</span>
            </span>
            <p class="text-slate-500 text-sm ml-6">
                Use an authentication app to receive an authentication code.
            </p>
        </label>

        <label
            class="block px-4 py-3 rounded-lg border border-slate-200 hover:bg-slate-100 transition-colors mb-6"
            :class="{ 'bg-slate-100': twoFactorType === 'sms' }"
        >
            <span
                class="flex items-center gap-2 text-slate-800 text-sm font-medium mb-1"
            >
                <input
                    type="radio"
                    name="two_factor_type"
                    v-model="twoFactorType"
                    value="sms"
                    class="form-radio"
                />
                <span>Through your Phone Number</span>
            </span>
            <p class="text-slate-500 text-sm ml-6">
                Use your phone number to receive an authentication code.
            </p>
        </label>
        <Errors :errors="errors" class="mb-6" />
        <div class="flex items-center justify-between">
            <button
                class="px-4 py-2.5 bg-white dark:bg-slate-800 rounded shadow dark:shadow-slate-900/50 border border-slate-200 text-slate-800 text-sm font-medium hover:bg-slate-50 transition-colors"
                @click="registerStore.setShowCancel2faModal(true)"
            >
                Setup later
            </button>
            <button
                class="px-4 py-2.5 bg-slate-800 rounded shadow justify-center text-white text-sm font-medium hover:bg-slate-700 transition-colors"
                @click="registerStore.gotoStep(3)"
            >
                Continue
            </button>
        </div>
    </div>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { ref, watch } from 'vue';
import { useRegisterStore } from '@/store/register';
import Errors from '@/components/errors.vue';

const registerStore = useRegisterStore();
const twoFactorType = ref(null);
const { errors } = storeToRefs(registerStore);

watch(twoFactorType, (val) => {
    registerStore.setTwoFactorType(val);
});
</script>
